import { EPDConformityOut } from "api-client";
import DropdownCheckbox from "components/DropdownCheckbox";
import React from "react";
import { observer } from "mobx-react-lite";
import { useTranslation } from "react-i18next";
import { searchStore } from "features/ProductSearch/SearchStore";
import { conformityStore } from "../../../store/ConformityStore.ts";

export default observer(function ConformityFilter({
  selected,
  setSelected,
  removingItem,
  handleRemoveItem,
}: {
  selected?: EPDConformityOut[];
  setSelected: React.Dispatch<React.SetStateAction<EPDConformityOut[]>>;
  removingItem?: EPDConformityOut;
  handleRemoveItem?: () => void;
}) {
  const { t } = useTranslation();

  const onChange = (value: EPDConformityOut[]) => setSelected(value);

  React.useEffect(() => {
    (async () => {
      await conformityStore.fetchConformities();
      searchStore.setFilterOptions({
        ...searchStore.filtersOptions,
        conformity: conformityStore.conformityOptions
          .filter((item) => item.name !== "")
          .sort((a, b) => a.name.localeCompare(b.name)),
      });
    })();
  }, []);

  if (!searchStore.filtersOptions.conformity) return <></>;

  const sortedList = searchStore.filtersOptions.conformity
    .slice()
    .sort((a, b) => a.name.localeCompare(b.name));

  return (
    <DropdownCheckbox<EPDConformityOut>
      displayKey={"name"}
      required={true}
      handleSelect={onChange}
      labelName={t("mapping.conformity")}
      name="conformity"
      items={sortedList}
      removeSelected={removingItem}
      handleRemoveSelected={handleRemoveItem}
      containerClassName="mr-0 sm:mr-3 min-w-[146px]"
      checkedItems={selected}
      optionsClassName="z-40 !max-w-fit"
      noMargin
    />
  );
});
